import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { getBrandRole, postBrandUser, putBrandUser } from "../../../services/StoreUsers/PostStoreUsers";
import { PostLoyaltyPoint, PutLoyaltyPoint } from "../../../services/LoyaltyPoint/LoyaltyPoint";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";
import { getStoreLocalData } from "../../../utils/localStorage";

const LoyaltyPointAddModal = ({
  loyaltyPointAddModalVisible,
  setLoyaltyPointAddModalVisible,
  sendDataToLoyaltyPoint,
  brandId,
  selectedLoyaltyPointValue,
}) => {
  const navigate = useNavigate();
  const [pointConversionUnit, setPointConversionUnit] = useState('');
  const [amountConversionUnit, setAmountConversionUnit] = useState('');
  const [statusValue, setStatusValue] = useState('');

  const { storeLocalData } = getStoreLocalData();
  
  const [pointConversionUnitError, setPointConversionUnitError] = useState('');
  const [amountConversionUnitError, setAmountConversionUnitError] = useState('');

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);


  useEffect(() => {
    if (selectedLoyaltyPointValue !== null) {
      setPointConversionUnit(selectedLoyaltyPointValue?.pointConversionUnit.toString() || '');
      setAmountConversionUnit(selectedLoyaltyPointValue?.amountConversionUnit.toString() || '');
      setStatusValue(selectedLoyaltyPointValue?.status || false);
    }
  }, [selectedLoyaltyPointValue]);

  const statusItems = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "DeActive",
      value: false,
    },
  ];

  const handleConfirmPickup = () => {
    setPointConversionUnitError('')
    setAmountConversionUnitError('')

    let isValid = true;
    if (!pointConversionUnit) {
      setPointConversionUnitError('Please Enter Point Conversion Unit');
      isValid = false;
    }
    if (!amountConversionUnit) {
      setAmountConversionUnitError('Please Enter Amount Conversion Unit');
      isValid = false;
    }
    
    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedLoyaltyPointValue === null) {
          // Logic for creating a new pickup request
          const data = {
            brandId: brandId,
            pointConversionUnit:pointConversionUnit,
            amountConversionUnit:amountConversionUnit,
            status: true
          };

          // Call the service function for creating pickup request

          PostLoyaltyPoint(brandId, data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const success = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                  }

                  setPointConversionUnit('');
                  setAmountConversionUnit('');
                  
                  setPointConversionUnitError('');
                  setAmountConversionUnitError('');
                  
                  setIsSubmitButtonPressed(false);
                  sendDataToLoyaltyPoint({
                    success: true,
                  });
                  setLoyaltyPointAddModalVisible(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        } else {
          const data = {
            ...selectedLoyaltyPointValue,
            brandId: brandId,
            pointConversionUnit: pointConversionUnit,
            amountConversionUnit: amountConversionUnit,
            status: statusValue,
          };
          // Call the service function for creating pickup request

          PutLoyaltyPoint(brandId, data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const success = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                  }

                  setPointConversionUnit('');
                  setAmountConversionUnit('');
                  
                  setPointConversionUnitError('');
                  setAmountConversionUnitError('');

                  setIsSubmitButtonPressed(false);
                  sendDataToLoyaltyPoint({
                    success: true,
                  });
                  setLoyaltyPointAddModalVisible(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  const handleModalClose = () => {
    setPointConversionUnit('');
    setAmountConversionUnit('');
    
    setPointConversionUnitError('');
    setAmountConversionUnitError('');

    setIsSubmitButtonPressed(false);
    sendDataToLoyaltyPoint({
      success: true,
    });
    setLoyaltyPointAddModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
         
        visible={loyaltyPointAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!loyaltyPointAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{  
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
              <img src="images/plus.png" alt="plus" style={{width:30}}/>
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Loyalty Point
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>
                      
              
            <div className="mx-4">
              <p>Example:</p>
              <p className="mx-4" style={{ color: 'blue' }}>If the bill amount is {storeLocalData?.currencySymbol} 100 and the Point Conversion Unit (P.C.U) is as per below example, then the Loyalty Points awarded will be</p>
              <p className="mx-4" style={{ color: 'blue' }}>{storeLocalData?.currencySymbol} 100 / 1 (P.C.U) = 100 Loyalty Points</p>
              <p className="mx-4" style={{ color: 'blue' }}>{storeLocalData?.currencySymbol} 100 / 2 (P.C.U) = 50 Loyalty Points</p>
              <p className="mx-4" style={{ color: 'blue' }}>{storeLocalData?.currencySymbol} 100 / 4 (P.C.U) = 25 Loyalty Points</p>
              
              </div>
              <div className="mx-4">
                <InputText
                  value={pointConversionUnit}
                  onChange={(e) => setPointConversionUnit(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Point Conversion Unit"
                  keyboardType='numeric'
                />
                {pointConversionUnitError && <p className="text-lg font-normal" style={{color:"red"}}>{pointConversionUnitError}</p>}
              </div>
             
              <div className="mx-4">
              <p>Example:</p>
              <p className="mx-4" style={{color:'blue'}}>If the Loyalty Point (L.P) is 100 and the Amount Conversion Unit (A.C.U) is as per below example, then the Amount Awarded against Loyalty Points will be</p>
              <p className="mx-4" style={{ color: 'blue' }}>100(L.P) / 1 (A.C.U) = {storeLocalData?.currencySymbol} 100 </p>
              <p className="mx-4" style={{ color: 'blue' }}>100(L.P) / 2 (A.C.U) = {storeLocalData?.currencySymbol} 50 </p>
              <p className="mx-4" style={{ color: 'blue' }}>100(L.P) / 4 (A.C.U) =  {storeLocalData?.currencySymbol} 25 </p>
              
              </div>
              <div className="mx-4">
                <InputText
                  value={amountConversionUnit}
                  onChange={(e) => setAmountConversionUnit(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Amount Conversion Unit"
                  keyboardType='numeric'
                />
                {amountConversionUnitError && <p className="text-lg font-normal" style={{color:"red"}}>{amountConversionUnitError}</p>}
              </div>
                
              {selectedLoyaltyPointValue !== null && (
                  <div className="mx-4 mt-4  ">
                    <FloatLabel>
                      <Dropdown
                        id="statusValue"
                        value={statusValue}
                        onChange={(e) => setStatusValue(e.value)}
                        options={statusItems}
                        optionLabel="name"
                        placeholder="Status"
                        className="w-full border-round-xl  text-2xl text-xl shadow-2"
                      />
                      <label
                        htmlFor="statusValue"
                        className="text-md"
                        style={{ color: "blue" }}
                      >
                        Status
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>
                )}
               
                <Button
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  onClick={handleConfirmPickup}
                  disabled={isSubmitButtonPressed}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Add
                  </p>
                </Button>
              
            </div>
           
        )}
      ></Dialog>
       <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default LoyaltyPointAddModal;
